import React from "react";
import { Card, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { DevForm } from "@components/Forms/Fields";
import { DefaultLayout } from "@components/Layouts";
import { url_reverse } from "@components/Utils";

export default function EventNewsletterHistoryItemScreen() {
    const { t } = useTranslation();
    const { event_slug, newsletter_id } = useParams();
    const apiUrl = url_reverse("api:event:newsletter_history:item", { event_slug, newsletter_id });
    const { apiData, setApiData } = useAppApi(apiUrl);

    if (!apiData) return;
    const header = (
        <>
            <Link to={url_reverse("admin:event:newsletter_history:list", { event_slug })}>{t("История рассылок")}</Link>
            <span> – </span>
            {t("Рассылка")}
        </>
    );
    const fieldProps = {
        apiData,
        setApiData,
    };
    return (
        <DefaultLayout>
            <Card>
                <Card.Header>{header}</Card.Header>
                <Card.Body>
                    <Form>
                        <DevForm.Field {...fieldProps} prefix="main" name="letter_subject" />
                        <DevForm.Field {...fieldProps} prefix="main" name="event_description" />
                        <DevForm.Field {...fieldProps} prefix="main" name="letter_subject_en" />
                        <DevForm.Field {...fieldProps} prefix="main" name="event_description_en" />
                        <DevForm.Field {...fieldProps} prefix="main" name="type" colField={4} />
                        <DevForm.Field {...fieldProps} prefix="main" name="emails" />
                        <DevForm.Field {...fieldProps} prefix="main" name="is_test" />
                    </Form>
                </Card.Body>
            </Card>
        </DefaultLayout>
    );
}
